export const SIGNUP_TERMS_VERSION = "2026-08-21";
export type SignupAgreementKey =
  "service" | "privacy" | "identity" | "marketing";

export const signupAgreements: Array<{
  key: SignupAgreementKey;
  title: string;
  required: boolean;
  summary: string;
  sections: Array<{ heading: string; body: string }>;
}> = [
  {
    key: "service",
    title: "온독 서비스 이용약관",
    required: true,
    summary: "회원 계정, 분양 신청, 거래 기록과 이용 제한의 기본 원칙",
    sections: [
      {
        heading: "서비스 목적",
        body: "온독은 책임 있는 반려견 분양을 위해 브리더 정보, 개체 자료, 신청·대화·결제·인도 기록을 연결하는 온라인 플랫폼입니다. 온독은 개별 분양계약의 당사자나 수의학적 진단기관이 아닙니다.",
      },
      {
        heading: "회원의 책임",
        body: "회원은 사실에 맞는 정보를 제공하고 계정과 인증수단을 안전하게 관리해야 합니다. 허위 자료, 동물복지를 해치는 행위, 플랫폼 밖 결제 유도, 사기·괴롭힘·권리 침해 행위를 해서는 안 됩니다.",
      },
      {
        heading: "거래와 분쟁",
        body: "분양 조건, 건강 보장, 반환·환불 범위는 거래 화면과 당사자 간 계약에서 확인해야 합니다. 결제·환불·정산은 표시된 상태와 적용 정책에 따라 처리되며, 열린 분쟁이 있으면 지급이 보류될 수 있습니다.",
      },
      {
        heading: "이용 제한과 탈퇴",
        body: "법령·약관 위반, 허위 검토자료, 안전 위해가 확인되면 게시·거래·계정 이용이 제한될 수 있습니다. 탈퇴 후에도 법령상 의무 또는 진행 중인 거래·분쟁에 필요한 기록은 정해진 기간 동안 보관될 수 있습니다.",
      },
    ],
  },
  {
    key: "privacy",
    title: "개인정보 수집·이용 동의",
    required: true,
    summary: "가입과 본인확인에 필요한 최소 개인정보의 목적·항목·보유기간",
    sections: [
      {
        heading: "수집 항목",
        body: "아이디, 암호화된 비밀번호, 성명, 생년월일, 휴대폰 번호, 이메일 주소, KCP 본인확인 결과 식별값과 인증 이력을 수집합니다.",
      },
      {
        heading: "이용 목적",
        body: "회원 식별과 가입, 중복·부정가입 방지, 계정 복구, 거래 당사자 확인, 중요 안내, 민원·분쟁 대응과 보안 기록 관리에 이용합니다.",
      },
      {
        heading: "보유기간",
        body: "회원 탈퇴 시 지체 없이 파기하는 것을 원칙으로 합니다. 다만 관계 법령의 보존 의무, 진행 중인 거래·분쟁, 부정 이용 방지를 위해 필요한 정보는 해당 목적과 법정 기간 동안 분리 보관할 수 있습니다.",
      },
      {
        heading: "동의 거부",
        body: "필수 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 다만 안전한 회원·거래 식별에 필요한 정보이므로 동의하지 않으면 회원가입을 진행할 수 없습니다.",
      },
      {
        heading: "제3자 제공",
        body: "회원가입 단계에서 개인정보를 독립된 제3자의 고유 목적으로 제공하지 않습니다. 향후 제공이 필요한 경우 제공받는 자, 목적, 항목과 보유기간을 별도로 알리고 필요한 동의를 받습니다.",
      },
    ],
  },
  {
    key: "identity",
    title: "본인확인 및 개인정보 처리위탁 안내",
    required: true,
    summary: "NHN KCP 휴대폰 본인확인과 서비스 운영 수탁 처리 안내",
    sections: [
      {
        heading: "본인확인",
        body: "온독은 휴대폰 본인확인을 위해 NHN KCP 인증창을 사용합니다. 인증 과정의 통신사·인증정보는 KCP 화면에서 처리되며, 온독은 인증 완료 결과와 가입에 필요한 확인 정보만 전달받습니다.",
      },
      {
        heading: "처리위탁",
        body: "서비스 운영 과정에서 본인확인, 결제, 인프라·보안, 알림 발송 업무를 전문 사업자에게 위탁할 수 있습니다. 수탁자와 위탁업무의 최신 목록은 개인정보처리방침에 공개하고 목적 외 처리를 제한합니다.",
      },
      {
        heading: "확인 사항",
        body: "성명·생년월일·휴대폰 번호가 본인확인 결과와 일치해야 가입할 수 있습니다. 타인의 정보를 사용하거나 인증 결과를 변조하면 가입과 서비스 이용이 제한될 수 있습니다.",
      },
    ],
  },
  {
    key: "marketing",
    title: "혜택·서비스 소식 수신 동의",
    required: false,
    summary: "이메일·문자 등을 통한 이벤트와 맞춤 소식 안내",
    sections: [
      {
        heading: "수신 내용",
        body: "신규 기능, 책임 분양 콘텐츠, 이벤트와 맞춤 추천 소식을 이메일 또는 문자로 안내할 수 있습니다.",
      },
      {
        heading: "선택과 철회",
        body: "동의하지 않아도 회원가입과 핵심 서비스를 이용할 수 있으며 언제든 철회할 수 있습니다. 거래·보안·정책 변경 등 필수 안내는 수신 동의와 관계없이 발송될 수 있습니다.",
      },
    ],
  },
];
